/* eslint-disable react/jsx-props-no-spreading */
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import ImageBannerContent from "@/components/molecules/confirmation-section/image-banner-content";
import LoginButtonSection from "@/components/molecules/confirmation-section/login-button-section";
import LoginWithImageBannerAvanti from "@/components/molecules/confirmation-section/login-with-image-banner-avanti";
import withBrand from "@/components/with-brand";
import { LoginButtonSectionProps } from "@/types/confirmation-types";

import Styles from "./confirmation-section.module.css";

function AboutCover({ brand: _brand, ...props }: LoginButtonSectionProps) {
  const { current } = useWizard();

  return (
    <div
      className="grid lg:grid-cols-12 lg:col-span-12 lg:order-1 gap-spacing-m md:gap-spacing-xl lg:gap-spacing-l h-fit"
      data-testid="about-cover-section"
    >
      {current.uiElementControls?.showAboutCoverSectionWithoutBanner && (
        <>
          {/* IMAGE BANNER */}
          <div className="relative overflow-hidden h-[88px] md:[120px] lg:h-full rounded-2xl lg:col-span-5 lg:order-2">
            <ImageBannerContent {...props} />
          </div>

          {/* LOGIN BUTTON SECTION */}
          <div className="bg-surface-neutral-option-1 lg:bg-dark-surface-accent-1-primary text-text-body lg:text-dark-text-title rounded-radius-xxl p-spacing-m md:p-spacing-l font-body-font lg:col-span-7 lg:order-1">
            <LoginButtonSection {...props} />
          </div>
        </>
      )}

      {current.uiElementControls?.showAboutCoverSectionWithBanner && (
        <>
          {/* banner */}
          <div
            className={`${Styles.bannerBg} text-text-functional rounded-radius-xxl lg:p-spacing-l font-body-font lg:col-span-12 lg:order-1 border-white border-2 h-[196px] md:h-full`}
          >
            <LoginWithImageBannerAvanti {...props} />
          </div>
          {/* LOGIN BUTTON SECTION */}
          <div className="bg-surface-neutral-option-1 rounded-radius-xxl p-spacing-m md:p-spacing-l font-body-font lg:col-span-12 lg:order-2 lg:hidden">
            <LoginButtonSection {...props} />
          </div>
        </>
      )}
    </div>
  );
}

export default withBrand(AboutCover);
